import { render, staticRenderFns } from "./x-multiselect.vue?vue&type=template&id=800befd2&scoped=true&"
import script from "./x-multiselect.vue?vue&type=script&lang=js&"
export * from "./x-multiselect.vue?vue&type=script&lang=js&"
import style0 from "./x-multiselect.vue?vue&type=style&index=0&id=800befd2&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800befd2",
  null
  
)

export default component.exports